import { getIcon } from 'components/WorkflowEditor/steps/availableSteps';
import useOnClickOutside from 'hooks/useOnClickOutside';
import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  activateWorkflow,
  deactivateWorkflow
} from 'redux/actions/workflowActions';
import DeleteWorkflowModal from './DeleteWorkflowModal';
import DuplicateWorkflowModal from './DuplicateWorkflowModal';
import './WorkflowBox.scss';

const WorkflowBox = (props, index) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const ref = useRef();

  const [isActive, updateIsActive] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [duplicateModalOpen, setDuplicateModalOpen] = useState(false);
  useOnClickOutside(ref, () => {
    updateIsActive(false);
  });

  const valid = !!props.data?.steps?.reduce((prev, curr) => prev && curr.data?.valid, true);

  function toggleActivation(e) {
    e.preventDefault();
    if (!valid) return;
    if (props.data.active) {
      dispatch(
        deactivateWorkflow({ id: props.data.id, name: props.data.name })
      );
      toast.info('Workflow deactivated');
    } else {
      dispatch(activateWorkflow({ id: props.data.id, name: props.data.name }));
      toast.info('Workflow activated');
    }
  }

  return (
    <>
      <DeleteWorkflowModal
        id={props.data.id}
        open={modalOpen}
        onClose={(e) => setModalOpen(false)}
      />
      <DuplicateWorkflowModal
        id={props.data.id}
        name={props.data.name}
        open={duplicateModalOpen}
        onClose={(e) => setDuplicateModalOpen(false)}
      />
      <div className="box workflow_box">
        <nav className="level is-mobile">
          <div
            id={`workflow-box-left-icon-edit-${props.index}`}
            onClick={(e) => {
              history.push(`/workflows/editor/${props.data.id}`);
            }}
            className="level-left icons"
          >
            <div className="level-item">
              {props.data.steps &&
                props.data.steps
                  .sort((a, b) => a.order - b.order)
                  .map((s, i) => {
                    return i + 1 === props.data.steps.length ? (
                      getIcon(s.type)
                    ) : (
                      <span>
                        {getIcon(s.type)} <i className="fa fa-caret-right"></i>
                      </span>
                    );
                  })}
            </div>
          </div>
          <div
            id={`workflow-box-name-${props.index}`}
            onClick={(e) => {
              history.push(`/workflows/editor/${props.data.id}`);
            }}
            className="level-left workflow_name"
          >
            <div className="level-item">
              <span>{props.data.name ? props.data.name : 'Draft'}</span>
            </div>
          </div>
          <div className="level-right">
            <div className="level-item">
              <input
                id="activateWorkflow"
                type="checkbox"
                name="activateWorkflow"
                className="switch is-rounded is-success"
                // onChange={toggleActivation}
                checked={props.data.active}
                disabled={!valid}
              />
              <label
                id={`workflow-box-activate-workflow-toggle-${props.index}`}
                onClick={toggleActivation}
                className="switch_label"
                htmlFor="activateWorkflow"
              ></label>
            </div>
            <div className="level-item">
              <div className={`dropdown is-right ${isActive ? 'is-active' : ''}`}>
                <div className="dropdown-trigger">
                  <button
                    id={`workflow-box-dropdown-open-${props.index}`}
                    aria-haspopup="true"
                    aria-controls="dropdown-menu"
                    className="button is-small"
                    onClick={(e) => {
                      updateIsActive(!isActive);
                    }}
                  >
                    <i className="menu fas fa-ellipsis-h"></i>
                  </button>
                </div>

                <div
                  className="dropdown-menu"
                  style={{ width: `${props.width}px` }}
                  id="dropdown-menu"
                  role="menu"
                  ref={ref}
                >
                  <div className="dropdown-content">
                    <Link
                      id={`workflow-box-dropdown-edit-${props.index}`}
                      to={`/workflows/editor/${props.data.id}`}
                      className="dropdown-item"
                    >
                      <i className="far fa-edit"></i> Edit
                    </Link>
                    <a
                      id={`workflow-box-dropdown-duplicate-${props.index}`}
                      href="#"
                      onClick={(e) => {
                        setDuplicateModalOpen(true);
                        updateIsActive(false);
                      }}
                      className="dropdown-item"
                    >
                      <i className="far fa-copy"></i> Duplicate
                    </a>
                    <a
                      id={`workflow-box-dropdown-delete-${props.index}`}
                      href="#"
                      onClick={(e) => {
                        setModalOpen(true);
                        updateIsActive(false);
                      }}
                      className="dropdown-item delete-item"
                    >
                      <i className="far fa-trash-alt"></i> Delete
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};
export default WorkflowBox;
